import {
  Pagination,
  Mousewheel,
  Navigation,
  Zoom,
  FreeMode,
  Thumbs,
} from "swiper/modules";
import Swiper from "swiper";

class Lightbox extends HTMLElement {
  constructor() {
    super();

    const targetId = "lightbox";
    const lightboxElement = this;
    const productMediaElement = document.querySelector("product-media");
    const swiperElement = lightboxElement.querySelector(".swiper");
    const thumbsElement = lightboxElement.querySelector(".swiper--thumb");
    const lightboxSliderElement =
      swiperElement.querySelector(".swiper-wrapper");
    const lightboxThumbsSliderElement =
      thumbsElement.querySelector(".swiper-wrapper");
    const swiperButtonNext = lightboxElement.querySelector(
      ".swiper-button-next"
    );
    const swiperButtonPrevious = lightboxElement.querySelector(
      ".swiper-button-previous"
    );
    const paginationElement = lightboxElement.querySelector(
      ".swiper__pagination"
    );
    const mobileBreakpoint = 320;
    const desktopBreakpoint = 640;
    const swiperConfig = {
      modules: [Mousewheel, Navigation, Pagination, Zoom, FreeMode, Thumbs],
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        enabled: true,
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrevious,
      },
      threshold: 10,
      edgeSwipeDetection: true,
      zoom: {
        maxRatio: 2,
      },
      thumbs: {
        swiper: thumbsElement,
        autoScrollOffset: 1,
      },
      breakpoints: {
        // when window width is >= 320px
        [mobileBreakpoint]: {
          slidesPerView: 1,
          spaceBetween: 12,
          direction: "horizontal",
          zoom: {
            minRatio: 1.1,
            maxRatio: 3,
          },
        },
        // when window width is >= 480px
        [desktopBreakpoint]: {
          slidesPerView: 1,
          centeredSlides: true,
          direction: "vertical",
          freeMode: {
            enabled: true,
            sticky: true,
          },
          spaceBetween: 0,
        },
      },
    };

    let swiper = new Swiper(swiperElement, swiperConfig);

    const swiperThumbsConfig = {
      modules: [Thumbs],
      threshold: 1,
      edgeSwipeDetection: true,
      breakpoints: {
        // when window width is >= 320px
        [mobileBreakpoint]: {
          slidesPerView: "auto",
          spaceBetween: 12,
          direction: "horizontal",
        },
        // when window width is >= 480px
        [desktopBreakpoint]: {
          slidesPerView: "auto",
          direction: "vertical",
          freeMode: {
            enabled: true,
            sticky: true,
          },
          spaceBetween: 12,
        },
      },
    };

    let swiperThumbs = new Swiper(thumbsElement, swiperThumbsConfig);

    window.addEventListener(
      "shopify:section:load",
      () => new Swiper(swiperElement, swiperConfig)
    );
    window.addEventListener(
      "shopify:section:load",
      () => new Swiper(thumbsElement, swiperThumbsConfig)
    );

    /**
     *
     * @param {HTMLElement} slideElement
     * @returns
     */
    const createHtmlForImage = (slideElement, index) => {
      const deeplinkTarget = slideElement.dataset.deeplinkTarget;
      const deeplinkLabel = slideElement.dataset.deeplinkLabel;
      const imageElement = slideElement.querySelector("img");
      const videoElement = slideElement.querySelector("video");
      if (window.innerWidth > 640) {
        if (videoElement) {
          return `
      <div class="swiper-slide variant-image" data-deeplink-target="${deeplinkTarget}" data-position="${index}">
        <div class="swiper-zoom-container style= "background-color: white;">
          ${videoElement.outerHTML}
        </div>
      </div>
    `;
        }
        if (imageElement) {
          return `
      <div class="swiper-slide variant-image" data-deeplink-target="${deeplinkTarget}" data-position="${index}">
        <div class="swiper-zoom-container">
          ${imageElement.outerHTML}
        </div>
      </div>
    `;
        }
      } else {
        if (videoElement) {
          return `
      <div class="swiper-slide variant-image" data-deeplink-target="${deeplinkTarget}" data-position="${index}">
        <div class="swiper-nozoom-container">
          ${videoElement.outerHTML}
        </div>
      </div>
    `;
        }
        if (imageElement) {
          return `
      <div class="swiper-slide variant-image" data-deeplink-target="${deeplinkTarget}" data-position="${index}">
        <div class="swiper-nozoom-container">
          ${imageElement.outerHTML}
        </div>
      </div>
    `;
        }
      }
    };

    /**
     * Handle update content.
     */
    const handleUpdateContent = () => {
      // Get product images that are currently displayed.
      const allActiveProductMedia = productMediaElement.querySelectorAll(
        ".swiper-slide:not(.js-hidden):not(.js-clone)"
      );
      const arrayOfProductMedia = [...allActiveProductMedia];

      // Remove all slides in the lightbox.
      lightboxSliderElement.innerHTML = "";

      arrayOfProductMedia.map((mediaElement, index) => {
        const htmlElement = createHtmlForImage(mediaElement, index);

        lightboxSliderElement.insertAdjacentHTML("beforeend", htmlElement);
      });

      lightboxThumbsSliderElement.innerHTML = "";

      arrayOfProductMedia.map((mediaElement, index) => {
        const htmlElement = createHtmlForImage(mediaElement, index);

        lightboxThumbsSliderElement.insertAdjacentHTML(
          "beforeend",
          htmlElement
        );
      });
    };
    const handleSingleClickSlide = () => {
      if (window.innerWidth > 640) {
        const sliders = document.querySelectorAll(".swiper-zoom-container");
        sliders.forEach((slider) => {
          slider.addEventListener("click", () => {
            swiper.zoom.toggle();
          });
        });
      }
    };

    // Event listener for listening to if a modal is opened and that modal is the zoomLightbox.
    // Previous code for this was using the modal-state event, but this was causing issues with the double click to zoom.
    // document.addEventListener("modal-state", (event) => {
    //   if (event.detail) {
    //     const eventDetails = event.detail;
    //     const deeplinkTarget = eventDetails.deeplinkTarget;

    //     if (
    //       eventDetails.targetId === targetId &&
    //       eventDetails.state === "open"
    //     ) {
    //       handleUpdateContent(deeplinkTarget);
    //       handleSingleClickSlide();
    //       swiper.updateSlides();
    //       swiperThumbs.updateSlides();
    //       const correctSlide = lightboxElement.querySelector(
    //         `.swiper-slide[data-deeplink-target="${deeplinkTarget}"]`
    //       );
    //       const startSliderPosition =
    //         correctSlide?.getAttribute("data-position");

    //       swiper.slideTo(startSliderPosition, 0);
    //       swiperThumbs.slideTo(startSliderPosition, 0);
    //     }
    //   }
    // });

    document.addEventListener("modal-state", (event) => {
      if (event.detail) {
        const eventDetails = event.detail;
        const deeplinkTarget = eventDetails.deeplinkTarget;

        if (
          eventDetails.targetId === targetId &&
          eventDetails.state === "open"
        ) {
          handleUpdateContent(deeplinkTarget);
          swiper.updateSlides();
          swiperThumbs.updateSlides();
          const correctSlide = lightboxElement.querySelector(
            `.swiper-slide[data-deeplink-target="${deeplinkTarget}"]`
          );
          const startSliderPosition =
            correctSlide?.getAttribute("data-position");

          swiper.slideTo(startSliderPosition, 0);

          // Remove default click event listener
          swiper.off("click");

          // Add a custom click event to enable single-click zoom
          swiper.on("click", function (e) {
            if (swiper.zoom.scale === 1) {
              swiper.zoom.in(e, false); // Zoom in on the clicked location
            } else {
              swiper.zoom.out();
            }
          });
        }
      }
    });
  }
}

customElements.define("lightbox-component", Lightbox);
